import React, { FC, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { PoliciesPermissionSetItems as Permission } from 'common/constants/permissions';
import Leads from './Leads';

export interface IViewTypeData {
  table: { locationSearch: string; selected: boolean; isInitialized: boolean };
  pipeline: { locationSearch: string; selected: boolean; isInitialized: boolean };
}

interface ILeadsContainer {
  leadViewPermission:
    | Permission.CRM_LEAD_VIEW
    | Permission.CRM_LEAD_VIEW_OWN
    | Permission.PT_CRM_LEAD_VIEW
    | Permission.PT_CRM_LEAD_VIEW_OWN;
}

const LeadsContainer: FC<ILeadsContainer> = ({ leadViewPermission }) => {
  const location = useLocation();

  const [viewTypeData, setViewTypeData] = useState<IViewTypeData>({
    table: { locationSearch: location.search, selected: false, isInitialized: false },
    pipeline: { locationSearch: location.search, selected: true, isInitialized: false },
  });

  const viewType = viewTypeData.table.selected ? 'table' : 'pipeline';
  const { locationSearch, isInitialized } = viewTypeData[viewType];

  return (
    <Leads
      key={viewType}
      viewType={viewType}
      locationSearch={locationSearch}
      setViewTypeData={setViewTypeData}
      viewTypeData={viewTypeData}
      isTableInitialized={isInitialized}
      leadViewPermission={leadViewPermission}
    />
  );
};

export default LeadsContainer;
